import base64url from 'base64url';
import pako from 'pako';
import xml2js from 'xml2js';

/* istanbul ignore file */
export const decodePaReq = (compressedBase64Str) => {
  let data = '';
  const buffer = Buffer.from(compressedBase64Str, 'base64');
  const unzipped = pako.inflate(buffer, { to: 'string' });
  const { parseString } = xml2js;
  const xml = unzipped.toString();
  parseString(xml, (err, result) => {
    if (err) throw new Error('Failed to parse XML');
    data = result;
  });
  return data;
};

export const decodeCReq = (base64UrlStr, replaceHash = false) => {
  let data = base64url.decode(base64UrlStr, 'utf8');

  if (replaceHash) {
    data = data.replace(/#/g, '"');
  }

  try {
    const result = JSON.parse(data);
    if (result.acsTransID) {
      return result;
    }
    return false;
  } catch (error) {
    return false;
  }
};
